export default {
  reportBuilder: 'Berichte',
  subheadline: 'Diese Einstellungen definieren das globale Erscheinungsbild von Qmulus generierten PDFs.',
};
